var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9324 11.2653L7.43279 0.244898C7.33592 0.0811225 7.16874 0 7 0C6.83126 0 6.66252 0.0811225 6.56721 0.244898L0.0675796 11.2653C-0.124597 11.5929 0.116014 12 0.500368 12H13.4996C13.884 12 14.1246 11.5929 13.9324 11.2653ZM6.50003 4.53061C6.50003 4.46327 6.55627 4.40816 6.62502 4.40816H7.37498C7.44372 4.40816 7.49997 4.46327 7.49997 4.53061V7.34694C7.49997 7.41429 7.44372 7.46939 7.37498 7.46939H6.62502C6.55627 7.46939 6.50003 7.41429 6.50003 7.34694V4.53061ZM7 9.91837C6.80375 9.91444 6.61689 9.83531 6.47951 9.69796C6.34214 9.5606 6.2652 9.37597 6.2652 9.18367C6.2652 8.99138 6.34214 8.80674 6.47951 8.66939C6.61689 8.53203 6.80375 8.4529 7 8.44898C7.19625 8.4529 7.38311 8.53203 7.52049 8.66939C7.65786 8.80674 7.7348 8.99138 7.7348 9.18367C7.7348 9.37597 7.65786 9.5606 7.52049 9.69796C7.38311 9.83531 7.19625 9.91444 7 9.91837Z",
    fill: "#F03738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.ae4f578570537546f94cec05521a16f9.svg";
export { ForwardRef as ReactComponent };